



























































































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import AuthenticationService from '@/service/AuthenticationService';
import DCPModeratorService from '@/service/DCPModeratorService';
import { Validations } from 'vuelidate-property-decorators';
import { email, requiredIf } from 'vuelidate/lib/validators';
import LoginPasswordResetModal from './LoginPasswordResetModal.vue';
import LoginModeratorMask from './LoginModeratorMask.vue';
import LoginParticipantMask from './LoginParticipantMask.vue';
import Base from './Base';
import LoginOffer from '@/views/LoginOffer.vue';
import ForgotPasswordModal from '@/components/modals/ForgotPasswordModal.vue';
import ResetPasswordModal from '@/components/modals/ResetPasswordModal.vue';
import { AxiosError } from 'axios';

@Component({
  components: {
    ResetPasswordModal,
    ForgotPasswordModal,
    LoginOffer,
    LoginPasswordResetModal,
    LoginModeratorMask,
    LoginParticipantMask
  }
})
export default class Login extends Base {
  form = {
    username: '',
    password: '',
    name: '',
    pin: '',
    email: ''
  };

  error = '';

  showForgotPassword = false;

  loginMode = 'participant' as 'moderator' | 'participant';


  @Validations()
  get validations() {
    return {
      form: {
        username: { required: requiredIf(() => this.loginMode === 'moderator') },
        password: { required: requiredIf(() => this.loginMode === 'moderator') },
        name: { required: requiredIf(() => this.loginMode === 'participant') },
        pin: { required: requiredIf(() => this.loginMode === 'participant') },
        email: {
          required: requiredIf(() => this.loginMode === 'participant' && this.theme.emailLogin),
          email: email
        }
      }
    };
  }

  @Watch('theme')
  themeChanged(): void {
    this.setLoginMode();
  }

  mounted(): void {
    this.checkSessionAndQueryParams();
    this.setLoginMode();

    if (this.$route.name === 'ResetPassword') {
      if (this.$route.query.token) {
        this.$bvModal.show('reset-password-modal');
      } else {
        this.$router.replace('/login');
      }
    }
  }

  checkSessionAndQueryParams() {
    if (this.$store.getters.username && this.$route.query.pin == undefined) {
      AuthenticationService.fetchMyAccount().then(() => {
        console.log('Redirect to /');
        this.$router.push('/');
      });
    } else if (this.$route.query.pin != undefined) {
      console.log('Ignoring authentication information. Pin Url parameter is given');
    }
  }

  setLoginMode(): void {
    if (this.$route.query.pin != undefined || this.$route.query.name != undefined) {
      this.loginMode = 'participant';
    } else if (localStorage.loginMode) this.loginMode = localStorage.loginMode;
    if (this.loginMode == 'participant') {
      let pin = this.$route.query.pin;
      let name = this.$route.query.name;
      if (this.theme.emailLogin) {
        let email = this.$route.query.email || this.$route.query['ext-email'];
        this.form.email = email ? email as string : '';
      }
      this.form.pin = pin ? pin as string : '';
      this.form.name = name ? name as string : '';

      if(this.theme.newDCP && this.$route.query.key) {
        DCPModeratorService.registerPinAndKey(this.form.pin, this.$route.query.key as string).catch(e => {
          const err = e as AxiosError;
          if (err.response && err.response.status === 404) {
            this.error = this.t('login.errors.notStarted');
          } else if(err.response && err.response.status === 403) {
            this.form.email = '';
            this.form.name = ''
            // remove key, name and email from query params
            const { key, name, email, ...rest } = this.$route.query;
            this.$router.replace({ path: '/login', query: { ...rest } });
          }
        })
      }

    }
  }

  login(): void {
    if (this.form.username && this.form.password) {
      console.log('Do login with username', this.form.username);
      AuthenticationService.login(this.form.username, this.form.password)
        .then((account) => {
          console.log('Login succeeded', account);
          this.$store.commit('setLayout', '');
          if (account && account.role !== 'USER') {
            console.log('Go to admin console', '/admin/console/running');
            this.$router.push('/admin/console/running');
          } else {
            console.log('Go to start page', '/');
            this.$router.push('/');
          }
        })
        .catch((err) => {
          console.log(err.response.data.message);
          if (err.response.status === 403 && err.response.data.message
            && (err.response.data.message as string).includes('too many failed logins')) {
            this.showForgotPassword = true;
          } else if (err.response.status === 403) {
            this.$bvModal.show('password-change');
            return;
          } else if (err.response.status === 500) {
            this.error =
              this.t('common.serverConnectionError');
          } else {
            this.error = this.t('login.errors.invalidUsernameOrPassword');
            localStorage.removeItem('access_token');
          }
        });
    } else {
      this.$v.form.username?.$touch();
      this.$v.form.password?.$touch();
      this.error = this.t('login.errors.invalidUsernameOrPassword');
    }
  }

  async startNewDCP(): Promise<boolean> {
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.error = this.theme.emailLogin
        ? this.t('login.errors.insertNamePinAndEmail')
        : this.t('login.errors.insertNameAndPin');
      return false;
    }

    console.debug("start new dcp");

    const dcpRootUrl = process.env.VUE_APP_DCP_URL;
    if (!dcpRootUrl) {
      alert('DCP_URL is not set');
      return false;
    }

    const pin = this.form.pin.replace(/[^0-9]/g, '');
    const key = this.$route.query.key as string | undefined;

    try {
      await DCPModeratorService.checkConferenceExists(pin);

      if (key) {
        try {
          await DCPModeratorService.registerPinAndKey(pin, key);
        } catch (e) {
          const err = e as AxiosError;
          if (err.response?.status === 404) {
            this.error = this.t('login.errors.notStarted');
          } else if (err.response?.status === 403) {
            this.error = this.t('login.errors.keyAlreadyUsed');
          }
          return false;
        }
      }

      const queryParams = new URLSearchParams();
      queryParams.set('username', this.form.name);

      if (this.theme.emailLogin) {
        if (!this.form.email) {
          this.error = this.t('login.errors.insertEmail');
          return false; // Früher Ausstieg, wenn E-Mail fehlt
        }
        queryParams.set('email', this.form.email);
      }

      // Alle weiteren Parameter aus der Route hinzufügen
      const routeQuery = this.$route.query;
      if (key) {
        queryParams.set('key', key);
      }
      if (routeQuery.endUrl) {
        queryParams.set('endUrl', routeQuery.endUrl as string);
      }

      const language = this.$i18n.locale;
      if (language) {
        queryParams.set('lang', language);
      }

      Object.entries(routeQuery).forEach(([paramKey, value]) => {
        if (paramKey.startsWith('ext-')) {
          queryParams.set(paramKey, value as string);
        }
      });

      const finalUrl = `${dcpRootUrl}/${pin}?${queryParams.toString()}`;
      console.log("Redirecting to DCP URL:", finalUrl);
      window.location.href = finalUrl;
      return true;

    } catch (err) {
      if (err.response && err.response.status === 404) {
        this.error = this.t('login.errors.notStarted');
      } else {
        this.error = this.t('common.serverConnectionError');
      }
      return false;
    }
  }

  async start(): Promise<void> {
    if (this.theme.newDCP) {
      await this.startNewDCP();
      return;
    }
    console.log('start old dcp');
    if (this.form.name && this.form.pin) {
      this.form.pin = this.form.pin.replace(/[^0-9]/g, '');

      const result = await AuthenticationService.checkDCPSessionExists(
        this.form.name,
        this.form.pin,
        this.theme.weblink.dataPinCheckUrl
      );
      switch (result.result) {
        case 'false':
          this.error = this.t('login.errors.noPresentation');
          return;
        case 'falseName':
          this.error = this.t('login.errors.falseName');
          return;
        case 'maxLimit':
          this.error =
            this.t('login.errors.falseName');
          return;
        case 'notStarted':
          this.error = this.t('login.errors.notStarted');
          return;
        case 'sessionLocked':
          this.error = this.t('login.errors.sessionLocked');
          return;
        case 'true': {
          console.log('PIN is ok');
          let endUrl = '';
          if (this.$route.query.endUrl) {
            endUrl = '&endUrl=' + this.$route.query.endUrl;
          } else {
            endUrl = this.theme && this.theme.weblink?.endUrl
              ? '&endUrl=' + this.theme.weblink.endUrl
              : '';
          }
          const dataUrl =
            this.theme && this.theme.weblink?.dataDcpUrl
              ? this.theme.weblink.dataDcpUrl
              : 'https://www.csnstart.de';

          let paramObject: any = {};
          Object.entries(this.$route.query).forEach(value => {
            if (value[0] === 'endUrl') return;
            if (value[0] !== 'pin') paramObject[value[0]] = value[1];
          });
          paramObject.name = this.form.name;
          const params = `?${new URLSearchParams(paramObject).toString()}`;
          const dcpUrl = `${dataUrl}/conference/dcp/${this.form.pin}${params}${endUrl}`;
          console.log('open dcp url', dcpUrl);

          window.location.href = dcpUrl;
          this.error = '';
          return;
        }
      }
    } else {
      this.error = this.t('login.errors.insertNameAndPin');
    }
  }

  toggleLogin(mode: 'participant' | 'moderator'): void {
    this.$v.$reset();
    this.error = '';
    this.loginMode = mode;
    localStorage.loginMode = mode;
  }

  getContactLink(): string {
    if (this.csn || !this.theme.textbox || !this.theme.textbox.testUrl)
      return `https://www.csn-gmbh.de/${this.en ? 'en/' : ''}kontakt`;
    return this.theme.textbox.testUrl;
  }

  changeLang(newLang: 'en' | 'de'): void {
    this.$i18n.locale = newLang;
    localStorage.setItem('language', newLang);
  }

  get hasSubdomain(): boolean {
    return this.theme.subdomain !== 'default';
  }

  get carouselCaptionContentPosition(): any {
    if (!this.theme.textbox) {
      return {};
    }
    const positions = this.theme.textboxPosition.split(' ');
    let x, y;
    if (positions.length != 2) {
      x = 'left';
      y = 'top';
    } else {
      x = positions[0];
      y = positions[1];
    }

    const style: any = {};

    console.log('X: ', x, ' Y: ', y);

    if (y == 'bottom') {
      style.bottom = '12%';
    } else if (y == 'center') {
      style.top = '50%';
      style.transform = 'translateY(-50%)';
    } else {
      style.top = '12%';
    }
    if (x == 'right') {
      style.right = '9%';
    } else if (x == 'center') {
      style.left = '50%';
      style.transform = 'translateX(-50%)';
    } else {
      style.left = '9%';
    }

    if (x == 'center' && y == 'center') {
      style.transform = 'translate(-50%, -50%)';
    }

    return style;
  }

  get backgroundClass(): string {
    return this.hasSubdomain
      ? 'bg-white'
      : 'bg-header text-white';
  }


}
